let getAccessTokenSilently = null;
let isAuthenticated = null;

export const sec = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: (func) => (getAccessTokenSilently = func),
  isAuthenticated: () => isAuthenticated,
  setIsAuthenticated: (func) => (isAuthenticated = func),
};
